import React, { useState } from "react";
import classNames from "classnames";
import Styles from "./DateInput.module.scss";
import { Input } from "@/shared/components";
import { sanitizeDate, toFormattedDate, toIsoDate } from "../helper";
import { useTranslation } from "react-i18next";

type DateInputProps = {
  name?: string | null | undefined;
  value?: string | null | undefined;
  onChange: (value: string | null | undefined, isValid: boolean) => void;
  fullWidth?: boolean;
  error?: boolean;
  errorMessage?: string;
  className?: string;
};

const DateInput = ({ name, value, onChange, fullWidth, error, errorMessage, className }: DateInputProps) => {
  const [formattedDate, setFormattedDate] = useState(toFormattedDate(value || ""));
  const [dateError, setDateError] = useState<string | null>(errorMessage || null);
  const { t } = useTranslation();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onDateChange = (event: any) => {
    const formatted = event.target.value;
    const pressedKey = event.nativeEvent.inputType;

    const sanitized = sanitizeDate(formatted, pressedKey);
    setFormattedDate(sanitized);

    const isoDate = sanitized.length === 10 ? toIsoDate(sanitized) : null;
    onChange(isoDate, !!isoDate);
  };

  const onDateBlur = () => {
    const isValid = isValidDate(formattedDate);
    setDateError(isValid ? null : t("validations.invalidDate"));
    if (!isValid) {
      onChange(null, false);
    }
  };

  return (
    <>
      <Input
        className={classNames(className && className, Styles.dateInput)}
        fullWidth={fullWidth}
        type="tel"
        maxLength={10}
        name={name || "date"}
        placeholder="TT.MM.JJJJ"
        value={formattedDate}
        onChange={onDateChange}
        onBlur={onDateBlur}
        // error={!!dateError || error}
        // errorMessage={dateError || errorMessage}
      />
      {(dateError || error) && <p className={Styles.errorMessage}>{dateError || errorMessage}</p>}
    </>
  );
};

export default DateInput;

// Helper function to validate date
function isValidDate(dateStr: string): boolean {
  if (!dateStr.match(/^\d{2}\.\d{2}\.\d{4}$/)) return false;
  const [day, month, year] = dateStr.split('.');
  const date = new Date(`${year}-${month}-${day}`);
  return date.getDate() === parseInt(day) && date.getMonth() + 1 === parseInt(month) && date.getFullYear() === parseInt(year);
}
